module.exports = __webpack_public_path__ + "img/latest-result-banner-bg-1.9ddc34e3.webp";